var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataTransferLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dataTransferLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 74,
    height: 75,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M53.176,35.69a1.859,1.859,0,0,1-1.858-1.858A13.023,13.023,0,0,0,38.309,20.823H20.345v8.053A1.861,1.861,0,0,1,17.2,30.219L3.575,17.21a1.856,1.856,0,0,1,0-2.686L17.2,1.515a1.86,1.86,0,0,1,3.142,1.343v8.053H35.831a19.226,19.226,0,0,1,19.2,19.2v3.717A1.859,1.859,0,0,1,53.176,35.69Z",
    transform: "translate(11.7 6.244)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M34.689,41.831V33.778H19.2A19.226,19.226,0,0,1,0,14.575V10.858a1.858,1.858,0,1,1,3.717,0A13.023,13.023,0,0,0,16.725,23.867H34.689V15.814a1.86,1.86,0,0,1,3.142-1.343L51.459,27.48a1.856,1.856,0,0,1,0,2.686L37.831,43.174A1.86,1.86,0,0,1,34.689,41.831Z",
    transform: "translate(7.266 25.066)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTransferLogo);
export default __webpack_public_path__ + "static/media/dataTransferLogo.2aec881cbf90f919ae098b79f69e3b58.svg";
export { ForwardRef as ReactComponent };